<template>
  <div class="ont-pagination-top" :class="extraClass">
    <el-pagination
      v-if="currentPage > 0"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      layout="prev, pager, next"
      :current-page="currentPage"
      :page-size="pageSize"
      :pageSizes="pageSizes"
      :total="total"
    ></el-pagination>
    <div class="max-msg" v-if="rtotal > 1000000">
      <div class="msg">
        {{ $t("all.maxMsg1") }}{{ $HelperTools.toFinancialVal(rtotal)
        }}{{ $t("all.maxMsg2") }}
      </div>
      <div class="msg">
        {{ $t("all.maxMsg3") }}{{ $HelperTools.toFinancialVal(1000000)
        }}{{ $t("all.maxMsg4") }}
      </div>
    </div>
  </div>
</template>

<script>
import HelperTools from "@/helpers/helper";

const { omit } = HelperTools.HelperTools;

export default {
  /**
   * 绘制页数导航
   *
   * total： 总页数
   * paramVal： 可选；特殊参数的值
   */
  name: "TurnThePage",
  props: ["total", "paramVal", "rtotal", 'extraClass'],
  data() {
    return {
      pageSize: 0,
      currentPage: 0,
      pageSizesTest: [10, 20],
      pageSizesMain: [10, 20],
      pageSizes: [10, 20, 30, 50, 100],
      options: [
        {
          value: "ALL",
          label: "ALL",
        },
        {
          value: "ONT",
          label: "ONT",
        },
        {
          value: "ONG",
          label: "ONG",
        },
        {
          value: "PAX",
          label: "PAX",
        },
      ],
      oepValue: this.getAssetParam(),
    };
  },
  watch: {
    $route: "setParams",
    total: "setParams",
    oepValue: "setAsset",
  },
  mounted() {
    this.setParams();
    /* console.log(this.$route.name); */
  },
  beforeCreate() {
    console.log("this.$route:", this.$route);
  },
  methods: {
    gerParams(key) {
      if (this.$route.params[key]) {
        return this.$route.params[key];
      }
      if (this.$route.query[key]) {
        return this.$route.query[key];
      }
    },
    getAssetParam() {
      return this.gerParams("assetName") || "ALL";
    },
    setAsset() {
      /* sessionStorage.setItem("asset_name", this.oepValue); */
      this.toFirstPage();
    },
    setParams() {
      this.currentPage = Number(this.gerParams("pageNumber"));
      this.pageSize = Number(this.gerParams("pageSize"));
      if (this.$route.params.net === "testnet") {
        this.pageSizes = this.pageSizesTest;
      } else {
        this.pageSizes = this.pageSizesMain;
      }
    },
    toFirstPage() {
      let params = {
        assetName: this.getAssetParam(),
        pageSize: 20,
        pageNumber: 1,
      };
      this.routerPush(params);
    },
    handleCurrentChange(val) {
      let params = { pageSize: this.gerParams("pageSize"), pageNumber: val };
      this.routerPush(params);
    },
    handleSizeChange(val) {
      let params = { pageSize: val, pageNumber: "1" };
      this.routerPush(params);
    },
    routerPush(params) {
      // 判断网络
      if (this.$route.params.net === "testnet") {
        params["net"] = "testnet";
      }

      // 判断是否有其他参数
      if (typeof this.paramVal !== "undefined") {
        params[this.$route.name] = this.paramVal;
      }

      if (this.$route.name === "Address" || this.$route.name === "Token") {
        params = {
          ...this.$route.query,
          ...params,
        };
        this.$router.push({
          name: this.$route.name,
          params: params,
          query:
            this.$route.name === "Address"
              ? omit(params, "address", "net")
              : omit(params, "contractHash", "net"),
        });

        return;
      }
      // 注意在view组件中需要用watch触发数据刷新！！
      this.$router.push({ name: this.$route.name, params: params });
    },
  },
};
</script>

<style scoped>
.ont-pagination-top {
  margin-top: 60px;
  text-align: right;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  width: 100%;
}
.max-msg {
  text-align: left;
}

.ont-pagination-top--withdownload {
  flex-direction: column;
  align-items: flex-end;
  width: auto;
}

.ont-pagination-top--withdownload  .max-msg {
  text-align: right;
  margin-top: 15px;
}

.msg {
  font-size: 14px;
  font-family: Avenir;
  color: rgba(0, 0, 0, 0.6);
  padding-bottom: 5px;
}

@media only screen and (max-width: 750px) {
  .ont-pagination-top {
    flex-flow: column;
    flex-direction: column-reverse;
  }
  .max-msg {
    text-align: right;
    font-size: 14px;
    font-family: Avenir;
  }
}
.total-data-lh {
  line-height: 32px;
}
</style>
<style>
.el-pager li {
  font-family: Avenir;
  /* padding: 0; */
  transition: all ease 0.3s;
}
.el-pager li:hover {
  color: #1067bb;
  transition: all ease 0.3s;
}
.el-pager li.active {
  color: #1067bb;
  transition: all ease 0.3s;
}
.el-pagination button {
  padding-right: 0;
}
.el-pagination .btn-next .el-icon {
  text-align: right;
}
.el-pagination {
  padding-right: 0;
}
.el-pagination button:disabled {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/common/OntPagination.vue